import React, { useState } from "react";
import OrderHeader from "shared/component/orderHeader/orderHeader";
import ImgTruck from "shared/assets/images/svg/truck_order.svg";
import OpenIcon from "shared/assets/images/svg/open_in_new.svg";
import Download from "shared/assets/images/svg/download_blue.svg";
import { OrderState } from "shared/helpers/constants";
import { formatDate, localize } from "shared/helpers/utils";
import { Link } from "react-router-dom";
import { useCustomerOrders } from "customer/orders/customer-orders.service";
import { downloadTicketBillPdf } from "shared/services/reportService";

const Completed = () => {
  const { orders: completedOrders } = useCustomerOrders([OrderState.Completed]);
  const [downloadingId, setDownloadingId] = useState(null);

  const handleDownloadPdf = async (ticketId) => {
    setDownloadingId(ticketId);
    await downloadTicketBillPdf(ticketId);
    setDownloadingId(null);
  };
  return (
    <div className="pending completed">
      <div className="container">
        <OrderHeader title="COMPLETED INVOICES" />
        <h1 className="page-title">completed invoices</h1>
        {completedOrders?.data?.map((o) => (
          <div className="box-pending">
            <div className="status">
              <img className="imgTruck" src={ImgTruck} alt="ImgTruck" />
              <span className="approved">{OrderState[o.status]}</span>
            </div>
            <div className="all-info">
              <div className="div-top">
                <div className="info">
                  <h1 className="title">{localize(o.authorizedPersonName)}</h1>
                  <span className="serial">{o.serialNumber}</span>
                  <span className="date">{formatDate(o.createdDate, " - hh:mm a")}</span>
                </div>
                <div className="action">
                  <Link to={`/order/${o.id}`} className="open text-decoration-none">
                    <img src={OpenIcon} alt="open" />
                    Open
                  </Link>
                  <button
                    className="download"
                    onClick={() => handleDownloadPdf(o.id)}
                    disabled={downloadingId === o.id}
                  >
                    <img src={Download} alt="download" />
                    {downloadingId === o.id ? "Generating..." : "Download"}
                  </button>
                </div>
              </div>
              <hr className="hr" />
              <div className="div-bottom">
                <div className="info">
                  <div className="box">
                    <h1>From</h1>
                    <span>{localize(o.pickupPoint)}</span>
                  </div>
                  {/*<div className="box">*/}
                  {/*  <h1>to</h1>*/}
                  {/*  <span>{localize(o.)}</span>*/}
                  {/*</div>*/}
                </div>
                <div className="div-price">
                  <button className="btn-blue">Pay {o.totalAmount}</button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Completed;
